import { render, staticRenderFns } from "./SectionCreateForm.vue?vue&type=template&id=7c74f0d8&scoped=true"
import script from "./SectionCreateForm.vue?vue&type=script&lang=js"
export * from "./SectionCreateForm.vue?vue&type=script&lang=js"
import style0 from "./SectionCreateForm.vue?vue&type=style&index=0&id=7c74f0d8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c74f0d8",
  null
  
)

export default component.exports